import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

type SideNavItem = {
  to: string;
  label: string;
  end?: boolean;
};

type SideNavProps = {
  items: SideNavItem[];
};

const SideNav: React.FC<SideNavProps> = ({ items }) => {
  return (
    <nav aria-label="Side navigation">
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                clsx(
                  'block rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-zinc-950/5 text-zinc-950 dark:bg-white/5 dark:text-white'
                    : 'text-zinc-500 hover:bg-zinc-950/5 hover:text-zinc-950 dark:text-zinc-400 dark:hover:bg-white/5 dark:hover:text-white'
                )
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SideNav;
